<template>
    <div class="content-v">
        <h3>Alles im Überblick</h3>

        <div class="content">

            <!--   First Row   -->

            <div class="box">
                <h4>Fakten</h4>

                <p>+ Nächtliche Überwachung von 23:00 - 05:00 Uhr</p>
                <p>+ Telefonische Benachrichtigung bei einsetzender Geburt oder Wolfsangriff</p>
                <p>+ Eigene Nutzung der Livebilder</p>
                <p>+ Vertrauensvoller Umgang mit Ihren Daten</p>
            </div>

            <div class="box">
                <h4>Technologie</h4>

                <p>+ High-Tech Kameras vom  Marktführer „HikVision“</p>
                <p>+ Keine Installation notwendig (Plug & Play)</p>
                <p>+ Weltweiter Zugriff, von allen Geräten aus.</p>
            </div>

            <div class="box">
                <p>+ Netzunabhängige LTE Lösungen: Wo es Netz gibt, kriegen wir Netz.  Unsere Stationen können sich in alle Deutschen Netze einloggen und wechseln bei Netzschwankungen sofort den Anbieter.</p>
                <p>+ Durch Hochleistungsserver kann der Livestream von mehreren Geräten aus gleichzeitig verfolgt werden, ohne dass mehr Datenvolumen verbraucht wird.</p>
            </div>

            <div class="box">
                <p>+ Sehr geringer Datendurchsatz durch modernen H265+ Codec.</p>
                <p>+ Integrierte Infrarot-Scheinwerfer sorgen für optimale Nachtsicht.</p>
                <p>+ Der Einsatz eines Weitwinkel-Objektivs verringert tote Winkel.</p>
                <p>+ Die Verbindung kann über LAN, W-LAN oder LTE hergestellt werden.</p>
            </div>

            <!--   Second Row   -->

            <div class="box">
                <h4>
                    Preise
                    <span class="note">( alle Preise sind Richtpreise und können je nach Gegebenheiten abweichen )</span>
                </h4>

                <h5>WEIDETIERE (Herdenschutz)</h5>

                <p>+ ab 169 €/Monat für die Überwachung von 23 – 5 Uhr</p>

                <button type="button" @click="activeLightbox = 'weidetiere'">weitere Informationen</button>
            </div>

            <div class="box">
                <h5>KÜHE (Geburtenkontrolle)</h5>

                <p>+ ab 249 €/Monat für die Überwachung von 23 – 5 Uhr</p>

                <button type="button" @click="activeLightbox = 'kuehe'">weitere Informationen</button>
            </div>

            <div class="box">
                <h5>PFERDE (Geburtenkontrolle)</h5>

                <p>+ ab 45,00 € einmalige Bereitstellungsgebühr (inkl. Porto und Versand)</p>
                <p>+ ab 14,60 €/Tag für die Überwachung von 23 – 5 Uhr</p>

                <button type="button" @click="activeLightbox = 'pferde'">weitere Informationen</button>

                <span class="note">Alle Preise zzgl. MwSt</span>
            </div>

            <div class="box">
                <h4>Team</h4>

                <p>+ Tiermedizinstudenten der TiHo Hannover, mindestens im 6. Semester.</p>
                <p>+ Angestellte mit Berufsausbildung im Bereich Tiermedizin/Landwirtschaft.</p>
                <p>+ Regelmäßige Schulungen.</p>
            </div>

        </div>

        <div class="dimmer" :class="{active: activeLightbox.length > 0}"></div>

        <div class="lightbox" :class="{active: activeLightbox == 'kuehe'}">
            <p>Ein Kamerasystem kann erworben oder gemietet werden. Eine Kalbung wird erst nach erkennbaren Problemen oder einer zu langen Geburtsdauer telefonisch gemeldet.</p>
            <p>ggf. zzgl. Kosten für LTE-Nutzung</p>

            <button type="button" @click="activeLightbox = ''">Schließen</button>
        </div>

        <div class="lightbox" :class="{active: activeLightbox == 'weidetiere'}">
            <p>Das Kamerasystem inklusive autarker Stromversorgung wird individuell zusammengestellt und muss erworben werden. Eine nächtliche Beunruhigung der Herde, wird umgehend gemeldet.</p>
            <p>ggf. zzgl. Kosten für LTE-Nutzung</p>

            <button type="button" @click="activeLightbox = ''">Schließen</button>
        </div>

        <div class="lightbox" :class="{active: activeLightbox == 'pferde'}">
            <p>Das Kamerasystem wird gemietet. Die einsetzende Geburt wird sofort telefonisch gemeldet.</p>
            <p>ggf. zzgl. Kosten für LTE-Nutzung</p>

            <button type="button" @click="activeLightbox = ''">Schließen</button>
        </div>
    </div>
</template>


<style scoped>
h3 {
    text-align: center;
    overflow: hidden;
}

h3:before {
    content: '';
    position: absolute;
    left: 0;
    top: .5em;
    /* background: #6F6F6F; */
    background: #3E3E3E;
    height: .1em;
    width: 50vw;
    border-radius: 1em;
    transform: translateX(-5.5em);
}

h3:after {
    content: '';
    position: absolute;
    right: 0;
    left: auto;
    top: .5em;
    /* background: #6F6F6F; */
    background: #3E3E3E;
    height: .1em;
    width: 50vw;
    max-width: none;
    min-width: auto;
    border-radius: 1em;
    transform: translateX(5.5em);
}

div.content {
    padding-top: 1em;
    padding-bottom: 0;
    text-align: center;
}

div.box {
    font-size: .955vw;
    width: 19.4em;
    height: 19.4em;
    background: #ECECEC;
    color: #000000;
    padding: 1.8em;
    display: inline-block;
    margin-bottom: 4em;
    position: relative;
    text-align: left;
    vertical-align: top;
}

div.box h4 {
    font-size: 1.3em;
    border-bottom: .2em solid #000000;
    padding-bottom: 1em;
    margin-top: 1em;
    position: relative;
}

div.box h4 span.note {
    font-size: .4em;
    font-weight: normal;
    position: absolute;
    left: 0;
    bottom: .2em;
}

div.box > span.note {
    position: absolute;
    bottom: 1em;
    left: 0;
    font-size: .6em;
    font-weight: normal;
    display: block;
    width: 100%;
    text-align: center;
}

div.box h5 {
    font-size: 1em;
    margin-top: 1em;
}

div.box p {
    font-size: .9em;
    color: inherit;
    width: 100%;
}

div.box button {
    -webkit-appearance: none;
    background: none;
    border: none;
    border-radius: 0;
    color: #557B94;
    font-size: .9em;
    width: 100%;
    text-align: center;
    cursor: pointer;
    transition: color .2s ease-in-out;
}

div.box button:hover {
    color: #00558D;
}

div.box:nth-child(1) {
    margin-right: 1.8em;
    background: #333333;
    color: #ffffff;
}

div.box:nth-child(1) h4 {
    border-bottom: .2em solid #ffffff;
}

div.box:nth-child(8) {
    margin-left: 1.8em;
    background: #333333;
    color: #ffffff;
}

div.box:nth-child(8) h4 {
    border-bottom: .2em solid #ffffff;
}

div.box:nth-child(2):after,
div.box:nth-child(3):after,
div.box:nth-child(5):after,
div.box:nth-child(6):after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: .2em;
    height: calc(100% - 4em);
    background: #C3C3C3;
    margin-top: 2em;
}

div.dimmer {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: -1000vw;
    z-index: 90;
    background: rgba(0, 0, 0, 0);
    transition: background-color .5s linear;
}

div.dimmer.active {
    left: 0;
    background-color: rgba(0, 0, 0, .25);
}

div.lightbox {
    position: fixed;
    width: 80vw;
    max-width: 40em;
    max-height: 40em;
    background: #fff;
    box-shadow: 0 0 1em #ccc;
    top: -2em;
    left: 50vw;
    transform: translate(-50%, -100%);
    z-index: 100;
    padding: 2em;
    transition: all .5s ease-in-out;
}

div.lightbox.active {
    top: 50vh;
    transform: translate(-50%, -50%);
}

div.lightbox button {
    -webkit-appearance: none;
    background: none;
    border: none;
    border-radius: 0;
    color: #557B94;
    font-size: .9em;
    width: 100%;
    text-align: center;
    cursor: pointer;
    transition: color .2s ease-in-out;
}

div.lightbox p {
    font-size: .9em;
}

@media only screen and (min-width: 2080px) {
    div.box {
        font-size: 1.05em;
    }

    div.lightbox {
        font-size: 1.05em;
    }
}


@media only screen and (max-width: 1338px) and (min-width: 760px) {
    div.box {
        font-size: 1.92vw;
        padding: 2em 2em;
    }

    div.box h4 {
        font-size: 1em;
    }

    div.box h5 {
        font-size: .8em;
    }

    div.box p {
        font-size: .8em;
    }

    div.box:nth-child(2):after,
    div.box:nth-child(6):after {
        content: none;
        background: none;
    }

    div.box:nth-child(3),
    div.box:nth-child(5) {
        padding-right: 3em;
        width: 20.4em;
    }

    div.box:nth-child(4),
    div.box:nth-child(6) {
        padding-left: 3em;
        width: 20.4em;
    }

    div.lightbox {
        font-size: 1.92vw;
    }
}

@media only screen and (max-width: 760px) {
    div.box {
        font-size: 4.5vw;
        padding: 1em;
        margin-bottom: 2em;
        height: auto;
    }

    div.box h4 {
        font-size: 1.2em;
    }

    div.box h5 {
        font-size: 1em;
    }

    div.box p {
        font-size: .88em;
    }

    div.box:nth-child(2),
    div.box:nth-child(3),
    div.box:nth-child(5),
    div.box:nth-child(6) {
        margin-bottom: 0;
    }

    div.box:nth-child(8) {
        margin-left: 0;
    }

    div.box:nth-child(2):after,
    div.box:nth-child(3):after,
    div.box:nth-child(5):after,
    div.box:nth-child(6):after {
        left: 0;
        top: auto;
        bottom: 0;
        height: .2em;
        width: calc(100% - 2em);
        margin-left: 1em;
    }

    div.lightbox {
        font-size: 4.5vw;
    }

    div.box > span.note {
        position: absolute;
        bottom: .2em;
    }
}
</style>


<script>
export default {
    data: () => {
        return {
            activeLightbox: ''
        }
    }
}
</script>